import React from 'react';
import { BannerContainer, BannerHeading, BannerText, BannerContent, BannerImageWrapper } from './offerBanner.styles';
import useExperienceApi from '../../../hooks/useExperienceApi';
import abTests from '../../../constants/abtests';
import { triggerECD2EventsOnload, handleControlVariant } from '../utils/handleControlVariant';

const OfferBanner = () => {
  const { targetedFeaturesFlowletId, targetedFeatures, conductricsDecisions } = useExperienceApi();

  const targetedFeature = targetedFeatures?.find(f => f.agentReport?.id === abTests.PRODMOVE_PROTECT_HOOK.apiCode);

  const { title = '', description = '', decisionName = '' } = targetedFeature || {};

  if (!targetedFeature) {
    if (conductricsDecisions.length > 0) {
      handleControlVariant({
        targetedFeaturesFlowletId,
        conductricsDecisions,
        defaultTestName: 'Prod Move Downsell',
      });
    }
    return null;
  }

  const { imageAsset } = targetedFeature;

  const testVariant = targetedFeature.agentReport?.variant || '';
  const testName = targetedFeature.agentReport?.testName || decisionName;

  triggerECD2EventsOnload({ testName, testVariant });

  return (
    <BannerContainer data-testid="offerBanner">
      {imageAsset?.url && (
        <BannerImageWrapper order={imageAsset?.position}>
          <img src={imageAsset.url} alt="" />
        </BannerImageWrapper>
      )}
      <BannerContent>
        <BannerHeading>{title}</BannerHeading>
        <BannerText>{description}</BannerText>
      </BannerContent>
    </BannerContainer>
  );
};

export default OfferBanner;
